import script from "./CustomIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomIcon.vue?vue&type=script&lang=ts&setup=true"

import "./CustomIcon.vue?vue&type=style&index=0&id=439ce1ab&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-439ce1ab"]])

export default __exports__